import tokens from '../tokens/js/tokens';
// Functions.
// -----------------------------------------------------------------------------
export const getSchemaVariant = ({ mode, schema, theme, variant }) => theme.palette.schema[schema][mode][variant];
export const getSchemaState = ({ state, ...args }) => getSchemaVariant(args)[state];
export const getWhiteColor = () => tokens.colors.white[100].value;
//# sourceMappingURL=palette.utils.js.map